import api from './api';

/**
 * Service for Application Decisions
 * Supports timeline-first routing with contingent awards
 */
export const decisionService = {
    async getDecisionsByProgram(programType, params = {}) {
        const response = await api.get(`/decision/program/${programType}`, {
            params,
        });
        return response.data;
    },

    async getDecisionsByApplication(applicationId) {
        const response = await api.get(
            `/decision/application/${applicationId}`
        );
        return response.data;
    },

    async getDecisionById(decisionId) {
        const response = await api.get(`/decision/${decisionId}`);
        return response.data;
    },

    async createDecision(decisionData) {
        const response = await api.post('/decision', decisionData);
        return response.data;
    },

    async updateDecision(decisionId, updates) {
        const response = await api.put(`/decision/${decisionId}`, updates);
        return response.data;
    },

    /**
     * Withdraw a decision the program still holds, so the application is
     * undecided again for that program. `reason` is optional and internal.
     */
    async withdrawDecision(decisionId, { reason } = {}) {
        const response = await api.post(`/decision/${decisionId}/withdraw`, {
            ...(reason ? { reason } : {}),
        });
        return response.data;
    },

    async finalizeDecision(decisionId, action) {
        const response = await api.post(`/decision/${decisionId}/finalize`, {
            action,
        });
        return response.data;
    },

    async getPendingContingent(params = {}) {
        const response = await api.get('/decision/pending-contingent', {
            params,
        });
        return response.data;
    },

    async getRoutingStatus(applicationId, programType) {
        const response = await api.get(
            `/decision/routing-status/${applicationId}/${programType}`
        );
        return response.data;
    },

    async getReviewableApplications(programType, term) {
        const response = await api.get(`/decision/reviewable/${programType}`, {
            params: { term },
        });
        return response.data;
    },

    async getDecisionEmailDraft(
        applicationId,
        programType,
        type,
        awardedCount
    ) {
        const url = `/decision/email-draft/${applicationId}/${programType}/${type}`;
        const response =
            awardedCount === undefined
                ? await api.get(url)
                : await api.get(url, { params: { awardedCount } });
        return response.data;
    },

    async previewDecisionEmail({
        applicationId,
        programType,
        type,
        messageToFaculty,
        awardedCount,
    }) {
        const response = await api.post('/decision/email-preview', {
            applicationId,
            programType,
            type,
            messageToFaculty,
            ...(awardedCount === undefined ? {} : { awardedCount }),
        });
        return response.data;
    },
};

export default decisionService;
